import React, { useContext as useContextCore } from 'react'
import { usePaymentMethodPanelContext } from '../Context'
import { useCheckoutContext } from '../../../index'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const context = useCheckoutContext()

  const { isPartial, setIsPartial, balance } = usePaymentMethodPanelContext()
  const net = context.orderNetAmount
  const [amount, setAmount] = React.useState<number>()

  const [errors, setErrors] = React.useState({})

  React.useEffect(() => {
    const newErrors: any = {}

    if (isPartial) {
      if (!amount) {
        newErrors.amount = '**Required'
      }

      if (amount > balance && balance > 0) {
        newErrors.amount = `Maximum valid amount is ${balance}`
      }

      if (balance <= 0) {
        newErrors.price = `You don't have payment balance`
      }
    }
    setErrors(newErrors)
  }, [isPartial, amount, balance])

  React.useEffect(() => {
    if (!isPartial) {
      setAmount(net)
    } else {
      setAmount(balance)
    }
  }, [net, balance, isPartial])

  return (
    <CoreProvider value={{ amount, setAmount, isPartial, setIsPartial, errors, balance, ...props }}>
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
